import React                      from 'react'
import { Button
       , Layout
       , Menu }                   from 'antd'
import { Observer }               from 'mobx-react'

import { TEXT
       , tr }                     from '../00_assets'
import { kde_api_workgroup_t }    from '../02_api'
import { MApp }                   from '../09_model_app'
import { avoid_closing_modal
       , EditButtons
       , ModalPrompt }            from '../10_ui'


import { MWorkGroups }            from './01_screen_workgroups_model'
import { create_workgroup_editor_model
       , WorkgroupEditor }        from './02_screen_workgroup_editor'



export const WorkgroupsList: React.FC = () =>
<Observer render={ ( ) =>
{
  const model = MWorkGroups.instance( )
      , workgroups = model.workgroups.data_for_page( 0 )
      , on_edit = ( row: kde_api_workgroup_t ) =>
        {
          const editor_model = create_workgroup_editor_model( row )
              , modal = ModalPrompt( tr( TEXT.WORKGROUPS_EDIT_TITLE )
                     , <WorkgroupEditor form={ editor_model } />
                     , async ( ) => 
                       {
                         if ( editor_model.has_errors( ) ) 
                              modal.update( { visible: true } ) ;
                         else
                           {
                              await model.workgroups.on_edit( row, editor_model.fields( ) )
                              modal.update( { visible: false } ) ;
                           }
                       }
                     ) ;
        }
      , on_select_group = (sel:any) =>
          model.selected_workgroup = parseInt( sel.key, 10 )
      , on_create = ( ) =>
        {
          const editor_model = create_workgroup_editor_model( { name: '' } as any )
          
          ModalPrompt( tr( TEXT.WORKGROUPS_NEW_TITLE )
                     , <WorkgroupEditor form={ editor_model } />
                     , async ( ) => 
                       {
                         if ( editor_model.has_errors( ) )
                              avoid_closing_modal( ) ; // { error: { code: -4321 } }
                         else
                              await model.workgroups.on_add( editor_model.fields( ) ) ;
                       }
                     , "plus"
                     ) ;
        }

  return <Layout.Sider className="bg-bg scrollable" width={240}>
      {
        MApp( ).can_edit_workgroups?
          <div className="flex-row flex-align-center p-3">
            <Button
              type="primary"
              className="w-100"
              onClick={ on_create }
              disabled={ workgroups.loading }
            >
              { tr( TEXT.WORKGROUPS_NEW_TITLE ) }
            </Button>
          </div>
        : null
      }
     <Menu
        mode="inline"
        selectedKeys={[model.selected_workgroup + '']}
        style={{ lineHeight: '64px' }}
        onSelect={ on_select_group }
      >
        {
          workgroups.data.map( entry =>
            <Menu.Item key={ entry.id } className="on-hover">
              {
                MApp( ).can_edit_workgroups?
                  <EditButtons
                    row={ entry }
                    onEdit={ on_edit }
                    onDelete={ model.workgroups.on_delete }
                  />
                : null 
              }
              { entry.name }
            </Menu.Item> )
        }
      </Menu>
     </Layout.Sider>
}} /> ;
